import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5 6a1 1 0 0 0-1.707-.707l-2 2a1 1 0 0 0 1.414 1.414L3 8.414V18a1 1 0 1 0 2 0zm4 3a2 2 0 1 1 4 0c0 .58-.247 1.187-.746 1.873-.503.69-1.189 1.367-1.946 2.093l-.182.174c-.679.649-1.408 1.346-1.973 2.06C7.541 15.974 7 16.914 7 18a1 1 0 0 0 1 1h6a1 1 0 1 0 0-2H9.33a5 5 0 0 1 .392-.56c.474-.598 1.103-1.2 1.81-1.877l.16-.154c.743-.711 1.557-1.504 2.18-2.36C14.496 11.19 15 10.171 15 9a4 4 0 0 0-8 0 1 1 0 0 0 2 0m9 0a2 2 0 1 1 2 2 1 1 0 1 0 0 2 2 2 0 1 1-2 2 1 1 0 1 0-2 0 4 4 0 1 0 6.646-3A4 4 0 1 0 16 9a1 1 0 1 0 2 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }